import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Seven christmas truths",
  "description": "",
  "published": "2008-12-24T00:00:00.000Z",
  "redirect_from": ["/blog/seven-christmas-truths/swizec/27"],
  "categories": "life, society",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Was going to write a post about anything, pour out some thoughts for you, one of my boring essays that for some reason you all keep reading, yes both of you. But since, given my current mood, that would instill too much fear and spoil someone's holidays I've decided just to play the tag game of spouting seven truths about oneself. `}<a parentName="p" {...{
        "href": "http://blog.mozganostroj.com/2008/12/24/sedem-resnic-ali-sedem-prasic/"
      }}>{`Sparkica tagged me`}</a>{`, now I feel so included and recognised it's almost heartwarming.`}</p>
    <ol>
      <li parentName="ol">{`I find miss piggy extremely sexy, always have, always will. For some reason this extends to real girls, just keep them round and juicy, I need something to hug comfortably without fear of breaking myself on a bone.`}</li>
      <li parentName="ol">{`I often go out of my way to say something in such a manner as to allow for it to become a quote later on. Most of the time they won't become quotes, but it's a valiant effort.`}</li>
      <li parentName="ol">{`Political correctness is bullshit. Nobody cares people and you should understand that any time you do something politically correct it just makes the rest of us laugh.`}</li>
      <li parentName="ol">{`I severely dislike people who get hung up on petty and frivolous crap all the time. Sadly this means I also hate most women because it often seems they don't do much else than get hung up on petty frviolous crap and in silly ways nontheless.`}</li>
      <li parentName="ol">{`Emos ... don't even get me started, you guys ruined perfectly good music with your stupid behaviour and clothes so that now we can't listen to it just because it's emo. Fuck you.`}</li>
      <li parentName="ol">{`I hate that at times I'm still too teenagery and care about something being emo or not. Why should I care? All that matters is whether I like it or not. Bah, stupid silly person.`}</li>
      <li parentName="ol">{`I wear only black not because it's such an awesome colour, not becuase it's simple and neither because it's slimming. I wear it because according to traditional colour theory black staves off evil and protects a person from bad crap. Sadly some people don't know this and continue to throw bad crap my way despite my clothes.`}</li>
    </ol>
    <p>{`So there you have it, seven truths about myself and now I'm supposed to list seven other bloggers, but here's the catch. I don't really know seven other bloggers who aren't niche specific, but follow the slovene convention of blogs being personal nonsense sputtering places. So here's a list of what I can think of: `}<a parentName="p" {...{
        "href": "http://www.had.si/"
      }}>{`had`}</a>{`, `}<a parentName="p" {...{
        "href": "http://ratoncrack.blogspot.com/"
      }}>{`rat on crack`}</a>{`, `}<a parentName="p" {...{
        "href": "http://robertbasic.com/blog/"
      }}>{`robert basic`}</a>{`, `}<a parentName="p" {...{
        "href": "http://dronyx.wordpress.com/"
      }}>{`dr. onyx`}</a>{` and fuck, that's it.`}</p>
    <p>{`No wonder I have so few readers! I'm not doing much reading myself, crud.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      